/**
 * F5 collection page behaviour: auto-submit the facet form on sort/filter
 * change, and a mobile filter drawer toggle. Progressive enhancement only —
 * the form works without JS via the Apply button.
 */
(function () {
  class F5Facets extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.form.addEventListener('change', () => {
        this.form.submit();
      });

      const toggle = this.querySelector('[data-filter-toggle]');
      const panel = this.querySelector('[data-filter-panel]');
      if (toggle && panel) {
        toggle.addEventListener('click', () => {
          const isOpen = panel.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', String(isOpen));
        });
      }
    }
  }

  if (!customElements.get('f5-facets')) {
    customElements.define('f5-facets', F5Facets);
  }
})();
